const TITLES = "Mr|Mrs|Ms|Miss|Dr|Master|Prof"
  .split("|")
  .map(label => ({
    label,
    value: label
  }))

export default TITLES



// WEBPACK FOOTER //
// ./src/AtomicContainers/BookTestDrive/TITLES.js